import React, { useContext } from 'react';
import { Trans, useTranslation } from 'react-i18next';
import MessageModal from '@wix/da-ds/pkg/modals/dsPresets/MessageModal';
import { CancelButton } from '@wix/da-ds/pkg/modals/dsPresets/MessageModal/buttons';
import BuyCoreBrandedButton from '../../../../../Button/core/dsPresets/BuyCoreBrandedButton';
import { MODAL_FOOTER_BUTTON_SIZE } from '@wix/da-ds/pkg/modals/dsPresets/Modal';
import BoostIllustration from '../BoostIllustration';
import { MobileContext } from '@wix/da-react-context/pkg/MobileContext';
import { BiData } from '@wix/da-bi/pkg/events';
import { ReferralType } from '@wix/da-bi/pkg/constants';
const BoostNoCoreModal = ({ isTier, onRequestClose })=>{
    const { t } = useTranslation();
    const isMobile = useContext(MobileContext);
    return /*#__PURE__*/ React.createElement(MessageModal, {
        isOpen: true,
        onRequestClose: onRequestClose,
        image: /*#__PURE__*/ React.createElement(BoostIllustration, null),
        variant: isMobile ? 'vertical' : 'horizontal',
        title: t(`boostDeviation.modal.title.noCore${isTier ? '.tier' : ''}`),
        message: /*#__PURE__*/ React.createElement(Trans, {
            i18nKey: `boostDeviation.modal.message.noCore${isTier ? '.tier' : ''}`
        }, "Core Members get free monthly boosts to make their deviation more visible in browse. Additional boosts can be purchased with points.", ' ', /*#__PURE__*/ React.createElement("a", {
            target: "_blank",
            className: "link",
            href: t('boostDeviation.learnMoreUrl'),
            rel: "noreferrer"
        }, "Learn more")),
        footerButtons: [
            /*#__PURE__*/ React.createElement(CancelButton, {
                key: "cancel",
                onClick: onRequestClose
            }, t('popup.cancel')),
            /*#__PURE__*/ React.createElement(BuyCoreBrandedButton, {
                key: "buy-core",
                biData: BiData({
                    evid: 375,
                    referral_info: ReferralType.BOOST_UPGRADE_CORE_POPUP
                }),
                size: MODAL_FOOTER_BUTTON_SIZE
            }, t('common.getCore'))
        ]
    });
};
BoostNoCoreModal.displayName = 'BoostNoCoreModal';
export default BoostNoCoreModal;

//# sourceMappingURL=BoostNoCoreModal.js.map